import { motion } from "framer-motion";

const line = {
  hidden: { y: "110%", rotate: 2 },
  show: (i) => ({ y: "0%", rotate: 0, transition: { duration: 1.15, ease: [0.16, 1, 0.3, 1], delay: i } }),
};

export const MaskLines = ({ lines, as: Tag = "h2", className = "", delay = 0, inView = false }) => {
  const M = motion[Tag] ?? motion.h2;
  const trigger = inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" };
  return (
    <M className={className} initial="hidden" {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span className="block origin-left" variants={line} custom={delay + i * 0.11}>
            {l}
          </motion.span>
        </span>
      ))}
    </M>
  );
};

export const Reveal = ({ children, className = "", delay = 0, y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
  >
    {children}
  </motion.div>
);
